const dayjs = require('dayjs')
const path = require('path')

function formatDate(datetime) {
	return dayjs(datetime).format('DD/MM/YYYY, hh:mm a')
}

function formatTime(datetime) {
	return dayjs(datetime).format('hh:mm a')
}

function idToTimestamp(id) {
	var timestamp = id.toString().substring(0, 8);
	return new Date(parseInt(timestamp, 16) * 1000);
}

function questionDifficultyName(val) {
	let name;
	switch (val) {
		case 1:
			name = "Easy"
			break;
		case 2:
			name = "Medium"
			break;
		case 3:
			name = "Hard"
			break;
	}
	return name
}

function batchTypeName(type) {
	if (type == 'L') return 'Personal'
	else if (type == 'G') return 'Departmental'
}

function questionType(qtype) {
	let question_type = "";
	switch (qtype) {
		case "DQ":
			question_type = "Descriptive";
			break;
		case "MCQ":
			question_type = "Multiple Choice";
			break;
		case "TF":
			question_type = "True/False";
			break;
		case "CL":
			question_type = "Custom Layout";
			break;
		case "DRAGDROP":
			question_type = "Drag & Drop";
			break;
		case "PATTERN":
			question_type = "Pattern";
			break;
		case "ORDERING":
			question_type = "Ordering";
			break;
		case "MATCHING":
			question_type = "Matching";
			break;
		case "NONE":
			question_type = "None";
			break;
	}
	return question_type;
}

function fileBasename(pathname) {
	return path.basename(pathname)
}

function goTo(url) {
	window.open(url)
}

function getRandomArr(arr, n) {
	let result = new Array(n),
		len = arr.length,
		taken = new Array(len);
	if (n > len)
		throw new RangeError("getRandom: more elements taken than available");
	while (n--) {
		let x = Math.floor(Math.random() * len);
		result[n] = arr[x in taken ? taken[x] : x];
		taken[x] = --len in taken ? taken[len] : len;
	}
	return result;
}

function clipartLayerWidthClass(width_perc) {
	//Return 100% default
	if (!width_perc) { return 'is-12' }
	let width_classes = { '25': 'is-3', '33': 'is-4', '50': 'is-6', '67': 'is-8', '75': 'is-9', '100': 'is-12' }
	return width_classes[width_perc]
}

function clipartLayerAlignmentClass(alignment) {
	//Return 100% default
	if (!alignment) { return 'is-justify-content-start' }
	let alignment_classes = { 'C': 'is-justify-content-center', 'L': 'is-justify-content-flex-start', 'R': 'is-justify-content-flex-end', }
	// let alignment_classes = { 'C' : 'is-justify-content-flex-start', 'L' : 'is-justify-content-flex-start', 'R' : 'is-justify-content-flex-end',}
	return alignment_classes[alignment]
}

// Question 
function customLayoutInputSize(size) {
	const size_obj = {
		'1': 'is-small',
		'2': 'is-medium',
		'3': 'is-large'
	}

	let size_txt = 'is-medium' //default medium
	if (size_obj[size]) {
		size_txt = size_obj[size]
	}
	return size_txt
}

function sortend(e, list) {
	const { oldIndex, newIndex } = e
	//Declaring a function
	function rearrange(array, oldIndex, newIndex) {
		if (oldIndex > newIndex) {
			array.splice(newIndex, 0, array[oldIndex])
			array.splice(oldIndex + 1, 1)
		}
		else {
			array.splice(newIndex + 1, 0, array[oldIndex])
			array.splice(oldIndex, 1)
		}
	}
	rearrange(list, oldIndex, newIndex)
}

function checkArraySortedOrderingQuestions(arr) {
	
	let sorted = true;

	// Also keep on filtering number
	let filter = {}

	for (let i = 0; i < arr.length - 1; i++) {
		let num_first_less_than_second = 0
		// i is only index, number is J actually for traversing

		// The new element should be just greater than all filtered in the previous step
		const filterKeys = Object.keys(filter)
		if(filterKeys.length && !arr[i].includes(Math.max(...filterKeys)+1)) return false
		
		const smallArr = [Math.min(...arr[i].filter(n => !filter[n]))]
		for (const j of smallArr) {
			for (const k of arr[i + 1]) {
				if ((j < k) && !filter[j]) {
					// Filter the lower number
					filter[j] = true
					num_first_less_than_second += 1
				}
			}

			// console.log({ j, smallArr, filter, nextArr : arr[i+1] })
			// return
		}

		if (!num_first_less_than_second) {
			// console.log("false", { smallArr, filter, nextArr : arr[i + 1] })
			return false
		}

	}
	return sorted
}

function clipartImageMargin(margin_num) {
	let mclass
	if (margin_num == null) {
		mclass = 'm-1'
	} else {
		let pre = (margin_num >= 0) ? 'm-' : 'negative-m'

		if (!Number.isInteger(margin_num)) {
			margin_num = margin_num.toString().split('.').join('-')
		}
		mclass = `${pre}${margin_num}`
	}
	return mclass
}

async function readQuestionLoud(msg_text) {
	return new Promise((resolve, reject) => {
		if ('speechSynthesis' in window) {
			// Speech Synthesis supported
			const msg = new SpeechSynthesisUtterance();
			msg.text = msg_text
			msg.addEventListener("end", (event) => {
				resolve({
					success : true,
					eventEnd : event
				})
			});
			window.speechSynthesis.speak(msg);
		} else {
			// Speech Synthesis Not Supported
			reject({
				success : false,
				msg : "Sorry, your browser doesn't support text to speech!"
			})
		}
	})
	
}

function normalizer(node) {
	return {
		id: node._id,
		label: node.name,
		children: node.children,
	};
}

export default {
	formatDate, formatTime, idToTimestamp, questionDifficultyName, batchTypeName, questionType, fileBasename, goTo, getRandomArr,
	clipartLayerWidthClass,
	clipartLayerAlignmentClass,
	customLayoutInputSize,
	sortend,
	checkArraySortedOrderingQuestions,
	clipartImageMargin,
	readQuestionLoud,
	normalizer
}